import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'; // เพิ่ม
import App from './App'
import SpinnerLoading from "./components/Loading/SpinnerLoading";

const queryClient = new QueryClient(); // เพิ่ม

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={configureStore()}>
    <QueryClientProvider client={queryClient}> {/* เพิ่ม */}
      <Suspense fallback={<SpinnerLoading modal={true} />}>
        <App />
      </Suspense>
    </QueryClientProvider> {/* เพิ่ม */}
  </Provider>
);

serviceWorker.unregister();